<template>
  <div
    id="kt_modal_relatorios_editar"
    ref="kt_modal_relatorios_editar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" v-if="this.id === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Relatório
          </h3>
          <h3 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Relatório
          </h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div
              class="col-sm-9 col-md-9 col-lg-10 col-xl-10 col-xxl-10 fv-row mb-2"
            >
              <label class="required form-label">Nome do relatório</label>
              <input
                :id="`txtNome`"
                type="text"
                class="form-control mb-2"
                placeholder="Nome do relatório"
                maxlength="255"
                v-model="relatorio.nome"
                v-on:keyup.enter="nextFocus(`txtDescricao`)"
              />
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["nome"] }}
              </div>
            </div>
            <div
              class="col-sm-3 col-md-3 col-lg-2 col-xl-2 col-xxl-2 fv-row mb-2"
            >
              <label class="col-form-label fw-bold fs-6">Ativo</label>
              <div class="d-flex align-items-center">
                <div
                  class="form-check form-switch form-check-custom form-check-solid"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="flexSwitchChecked"
                    :checked="relatorio.ativo === '1'"
                    @change="
                      relatorio.ativo = relatorio.ativo === '1' ? '0' : '1'
                    "
                  />
                  <label
                    class="form-check-label fw-bold"
                    for="flexSwitchChecked"
                  ></label>
                </div>
                <div class="fv-plugins-message-container invalid-feedback">
                  {{ errosValidacao["ativo"] }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row mb-4"
            >
              <label class="required form-label">Descrição do relatório</label>
              <textarea
                :id="`txtDescricao`"
                class="form-control mb-2"
                maxlength="500"
                style="height: 150px"
                v-model="relatorio.descricao"
              />
              <div class="text-end text-muted fs-7">
                {{
                  this.relatorio.descricao
                    ? this.relatorio.descricao.length
                    : "0"
                }}/500 caracteres
              </div>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["descricao"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 fv-row mb-4"
            >
              <label class="form-label">Módulo</label>
              <select class="form-select" v-model="this.relatorio.modulo">
                <option
                  v-for="modulo in modulos"
                  v-bind:key="modulo.nome"
                  v-bind:value="modulo.nome"
                >
                  {{ modulo.nome }}
                </option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["modulo"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6 fv-row mb-4"
            >
              <label class="form-label">Grupo de usuários</label>
              <select
                class="form-select"
                v-model="this.relatorio.id_tipo_usuario"
              >
                <option
                  v-for="tipo in emitenteTipoUsuarios"
                  v-bind:key="tipo.id"
                  v-bind:value="tipo.id"
                >
                  {{ tipo.tipo }}
                </option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["id_tipo_usuario"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <label class="form-label mt-2 mb-8">Arquivo do Relatório</label>
              <div class="card-body pt-0">
                <div
                  id="imgArquivoRelatorio"
                  class="image-input image-input-outline"
                  data-kt-image-input="true"
                >
                  <div
                    class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                    v-if="this.relatorio.arquivo"
                    :style="{
                      'background-image': `url(media/svg/files/doc-dark.svg)`,
                    }"
                    @click="downloadArquivo()"
                  ></div>
                  <div
                    class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                    v-else
                    :style="{
                      'background-image': `url(media/svg/files/doc.svg)`,
                    }"
                  ></div>
                  <label
                    v-if="this.relatorio.padrao === '0'"
                    class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                    data-kt-image-input-action="change"
                    data-bs-toggle="tooltip"
                    data-bs-dismiss="click"
                    title="Alterar relatório"
                  >
                    <i class="bi bi-pencil-fill fs-7"></i>
                    <input
                      v-if="this.relatorio.padrao === '0'"
                      ref="fileInputRelatorio"
                      type="file"
                      name="relatorio"
                      accept=".frx"
                      @input="pickFileRelatorio"
                    />
                    <input type="hidden" name="relatorio_remove" />
                  </label>
                  <span
                    v-if="this.relatorio.padrao === '0'"
                    class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                    data-kt-image-input-action="remove"
                    data-bs-toggle="tooltip"
                    @click="removerRelatorio()"
                    data-bs-dismiss="click"
                    title="Remover relatório"
                  >
                    <i class="bi bi-x fs-2"></i>
                  </span>
                </div>
                <div
                  class="form-text mt-6"
                  v-if="
                    this.relatorio.arquivo === undefined ||
                    this.relatorio.arquivo === null ||
                    this.relatorio.arquivo.length <= 0
                  "
                >
                  <span class="badge badge-danger"
                    >Nenhum relatório selecionado</span
                  >
                </div>
                <div class="form-text mt-6">Apenas *.frx é aceito</div>
                <div class="fv-plugins-message-container invalid-feedback m-0">
                  {{ errosValidacao["arquivo"] }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            :id="`btnConfirmar`"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalEditarRelatorio'"
    :mensagem="this.mensagemLoading"
    v-if="this.loadingDownload === true"
  ></LoadingModal>
</template>

<script>
import { useToast } from "vue-toastification";
import {
  hideModal,
  getOrCreateInstanceModal,
  hideModalId,
} from "@/core/helpers/dom";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
const toast = useToast();

const relatorioInicializado = {
  id: 0,
  nome: "",
  descricao: "",
  id_tipo_usuario: 0,
  tipo_relatorio: 0,
  modulo: "",
  guid: "",
  arquivo: "",
  ativo: "1",
  padrao: "0",
};

export default {
  emits: ["exibirEditarRelatorioModal", "confirmarEditarRelatorioModal"],
  components: { LoadingModal },
  props: {
    id: { type: Number, required: true },
    relatorioEditar: { type: Object, required: false },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = [];
      this.loading = true;
      if (this.id <= 0) {
        try {
          this.relatorio.guid = this.$utils.generateUuidv4();
          let formData = this.$utils.convertModelToFormData(this.relatorio);
          var ret = await this.$store.dispatch(
            "relatorios/postRelatorios",
            formData
          );
          if (ret.Success === true) {
            toast.success("Relatório cadastrado com sucesso!", {
              timeout: 3000,
            });
            this.$emit("confirmarEditarRelatorioModal", false);
            hideModal(this.$refs.kt_modal_relatorios_editar);
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      } else {
        try {
          let formData = this.$utils.convertModelToFormData(this.relatorio);
          var retPut = await this.$store.dispatch(
            "relatorios/putRelatorios",
            formData
          );
          if (retPut.Success === true) {
            toast.success("Relatório alterado com sucesso!", { timeout: 3000 });
            this.$emit("confirmarEditarRelatorioModal", false);
            hideModal(this.$refs.kt_modal_relatorios_editar);
          }
        } catch (error) {
          this.errosValidacao = error;
        }
      }
      this.loading = false;
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_relatorios_editar);
      this.$emit("exibirEditarRelatorioModal", false);
    },
    async carregarEmitenteTipoUsuarios() {
      try {
        var retOdata = await this.$store.dispatch(
          "emitenteTipoUsuario/getEmitenteTipoUsuarioOData",
          "?$select=id,tipo,id_empresa&$orderby=tipo asc"
        );
        if (retOdata.value !== null && retOdata.value.length > 0) {
          this.emitenteTipoUsuarios = retOdata.value;
        } else {
          this.emitenteTipoUsuarios = [];
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    async carregarModulos() {
      try {
        var retOdata = await this.$store.dispatch(
          "relatoriosModulos/getRelatoriosModulosOData",
          "?$select=id,nome&$orderby=nome asc"
        );
        if (retOdata.value !== null && retOdata.value.length > 0) {
          this.modulos = retOdata.value;
        } else {
          this.modulos = [];
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    pickFileRelatorio() {
      let input = this.$refs.fileInputRelatorio;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          if (this.relatorio.arquivo && this.relatorio.arquivo !== null) {
            this.relatorio.arquivoRemover = this.relatorio.arquivo.replace(
              this.$utils.getUrl(),
              ""
            );
          }
          this.relatorio.arquivo = e.target.result;
          this.relatorio.formFileArquivo = file[0];
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    removerRelatorio() {
      if (
        this.relatorio.arquivo !== undefined &&
        this.relatorio.arquivo !== null &&
        this.relatorio.arquivo.length > 0
      ) {
        this.relatorio.arquivoRemover = this.relatorio.arquivo.replace(
          this.$utils.getUrl(),
          ""
        );
      } else {
        this.relatorio.relatorioRemover = "";
      }

      this.relatorio.arquivo = "";
      this.relatorio.formFileArquivo = null;
      this.$refs.fileInputRelatorio.value = null;
    },
    async downloadArquivo() {
      try {
        this.loadingDownload = false;
        this.mensagemLoading =
          "Aguarde, consultando arquivo para o download...";

        await this.exibirModalLoading(true);

        let result = await this.$store.dispatch(
          "relatorios/downloadRelatorio",
          this.id
        );

        if (result.Success === true) {
          var fileURL = [];
          if (result.Data.FileContents) {
            let blob = this.$utils.dataToBlob(result.Data);
            fileURL = window.URL.createObjectURL(new Blob([blob]), {
              type: "application/octet-stream",
            });
          } else {
            fileURL = window.URL.createObjectURL(new Blob([result.Data]), {
              type: "application/octet-stream",
            });
          }
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute(
            "download",
            this.relatorio.arquivo.replace("/", "")
          );
          document.body.appendChild(fileLink);
          fileLink.click();
        } else {
          await this.showInvalidAlert(result.Message);
        }
      } catch (error) {
        if (error.Message) {
          await this.showInvalidAlert(error.Message);
        }
      }
      await this.exibirModalLoading(false);
      this.loadingDownload = false;
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loadingDownload = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalEditarRelatorio");
      } else {
        await this.sleep(500);
        hideModalId("loadingModalEditarRelatorio");
        await this.sleep(100);
        this.loadingDownload = false;
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  async mounted() {
    this.loading = true;
    await this.carregarEmitenteTipoUsuarios();
    await this.carregarModulos();
    this.errosValidacao = [];

    if (this.id <= 0) {
      this.relatorio = JSON.parse(JSON.stringify(relatorioInicializado));
    } else {
      try {
        let ret = await this.$store.dispatch(
          "relatorios/getRelatorios",
          this.id
        );

        if (ret.Success === true) {
          this.relatorio = ret.Data;
        }
      } catch (error) {
        console.log(error);
      }
    }

    this.loading = false;
    setTimeout(() => {
      this.nextFocus(`txtNome`);
    }, 800);
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      loadingDownload: false,
      relatorio: {},
      modulos: [],
      emitenteTipoUsuarios: [],
      mensagemLoading: "Aguarde, preparando o arquivo para download",
    };
  },
};
</script>

<style></style>
